module.exports = __webpack_public_path__ + "img/emo_52.f90edb8f.png";